import React from 'react';

const AboutSection = () => {
  return (
    <section id="about" className="py-24 bg-white">
      <div className="container mx-auto px-6">
        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16">
            {/* Left: Main Story */}
            <div className="space-y-8">
              <div className="text-orange-400 text-sm font-medium tracking-wider mb-4">
                ABOUT US
              </div>
              
              <h2 className="text-4xl lg:text-5xl font-serif text-gray-900 leading-tight">
                一場從<span className="text-orange-500">荷蘭啟航</span>、<br />
                無國界的生命通關遊戲
              </h2>
              
              <div className="space-y-6 text-gray-700 leading-relaxed">
                <p className="text-lg">
                  為了給下一代更具創造力的快樂環境，創辦人 <span className="font-bold text-orange-600">2019 年移居荷蘭</span>，意外在 <span className="font-bold text-orange-600">2020 年開啟了明悅心創的全球起點</span>。而遊戲發明人 2016 年因在荷蘭目睹財務悲劇，歷時 <span className="font-bold text-orange-600">999 天</span>打造出這座低成本、高容錯的生命實驗室。他在台灣播種，明悅心創在荷蘭接棒，完成了不可思議的跨國連結。
                </p>

                <p className="text-lg">
                  我們深信，未來最核心的競爭力是主動將人生視為實驗遊戲的「<span className="font-bold text-orange-600">高能動性（High Agency）</span>」。我們不強調冰冷科技，而是專注「看見活生生的人」，在遊戲中連結彼此、鍛鍊三大底層心態：
                </p>

                <ul className="space-y-3 pl-1">
                  <li className="flex gap-3">
                    <span className="text-orange-500 font-bold flex-shrink-0">•</span>
                    <span><span className="font-semibold text-gray-900">自主迭代：</span>藉由專案式模擬，帶著解決問題的目的自主學習。</span>
                  </li>
                  <li className="flex gap-3">
                    <span className="text-orange-500 font-bold flex-shrink-0">•</span>
                    <span><span className="font-semibold text-gray-900">框架思考（超越對錯）：</span>跳脫評判，以強大覺察力破除二元對立，建立包容萬物的人生框架。</span>
                  </li>
                  <li className="flex gap-3">
                    <span className="text-orange-500 font-bold flex-shrink-0">•</span>
                    <span><span className="font-semibold text-gray-900">價值顯化：</span>打造受用一生的心智系統，將經驗轉化為真正的生命價值。</span>
                  </li>
                </ul>

                <p className="text-lg italic font-semibold text-gray-900">
                  這套系統以財商切入，本質卻是無邊界的教育革命。
                </p>

                <p className="text-lg">
                  現在，我們正帶領核心教練團，從個人商業模式走向「<span className="font-bold text-orange-600">全球版權與文化輸出</span>」。我們以台灣為基地，將高效的遊戲化教學與引導系統輸出至歐洲及全球。
                </p>

                <p className="text-lg">
                  我們深知，面對時代變遷的集體焦慮，唯有透過社會教育的「<span className="font-bold text-orange-600">代際傳承</span>」——讓富足的心態成為代代相傳的傳家寶，才能從根本解鎖群體的生存恐懼。明悅心創將持續以時代的永續格局與明月般的溫暖，陪伴全球更多學校、家庭與企業解鎖內在掌控力。當個體與家庭重拾豐盛的底氣，便能更有勇氣孕育新生命、傳承新文化，共同迎接一個物質富足與精神安詳、代代「<span className="font-bold text-orange-600">富而喜悅</span>」的新世代。
                </p>
              </div>
            </div>

            {/* Right: Mission & Vision */}
            <div className="space-y-8">
              <div className="bg-gradient-to-br from-orange-50 to-amber-50 rounded-2xl p-8 border border-orange-100">
                <div className="text-orange-500 text-sm font-medium tracking-wider mb-4">
                  MISSION · 使命
                </div>
                <p className="text-gray-700 leading-relaxed">
                  以遊戲化學習打造理性心智沙盒，陪伴現代人卸下防禦、修復金錢焦慮，批量鍛鍊面對未知變局時的「高能動性」。
                </p>
              </div>

              <div className="bg-gradient-to-br from-orange-50 to-amber-50 rounded-2xl p-8 border border-orange-100">
                <div className="text-orange-500 text-sm font-medium tracking-wider mb-4">
                  VISION · 願景
                </div>
                <p className="text-gray-700 leading-relaxed">
                  成為全球最具影響力的生命教育與遊戲化學習文化機構，引領家庭與組織活出「富而喜悅」的生命文化。
                </p>
              </div>

              {/* Core Values Pills */}
              <div className="flex flex-wrap gap-3">
                <span className="px-4 py-2 bg-white border-2 border-orange-200 rounded-full text-sm text-gray-700">
                  Intellectual 理性
                </span>
                <span className="px-4 py-2 bg-white border-2 border-orange-200 rounded-full text-sm text-gray-700">
                  High Agency 高能動性
                </span>
                <span className="px-4 py-2 bg-white border-2 border-orange-200 rounded-full text-sm text-gray-700">
                  School-age 童心
                </span>
                <span className="px-4 py-2 bg-white border-2 border-orange-200 rounded-full text-sm text-gray-700">
                  Wealth & Joy 富而喜悅
                </span>
              </div>

              {/* Group Photo */}
              <div className="mt-8 rounded-2xl overflow-hidden shadow-2xl">
                <img
                  src="https://customer-assets.emergentagent.com/job_instant-website-93/artifacts/2mkgtjum_%E9%A6%96%E9%A0%81%E7%85%A7%E7%89%87.jpg"
                  alt="明悅心創財富流戶外大型沙盤活動 — 童心、高能動性、富而喜悅"
                  className="w-full h-auto object-cover"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;